module.exports = __webpack_public_path__ + "img/selected5-min.0e1ee1b1.png";